// Le pull `/sync/full` alimente aussi le modèle de lecture local.
import { TYPE_DES_COLLECTIONS_DU_PULL, TYPES_COUVERTS_PAR_LE_PULL } from './kinds';
import { ecrireEntitesServeur, noterChangementRecu, purgerAbsentes, supprimerEntitesServeur } from './store';

export async function fusionnerPageDuPull(reponse) {
  const donnees = reponse?.data?.data ? reponse.data : reponse?.data ?? reponse ?? {};
  const contenu = donnees.data ? donnees.data : donnees;
  let recus = 0;
  for (const [collection, kind] of Object.entries(TYPE_DES_COLLECTIONS_DU_PULL)) {
    if (Array.isArray(contenu[collection])) recus += await ecrireEntitesServeur(kind, contenu[collection]);
  }
  if (Array.isArray(contenu.trip_updates)) {
    const parTrajet = {};
    contenu.trip_updates.forEach((suivi) => {
      if (!suivi?.trip_id) return;
      (parTrajet[suivi.trip_id] = parTrajet[suivi.trip_id] || []).push(suivi);
    });
    for (const [tripId, suivis] of Object.entries(parTrajet)) {
      await ecrireEntitesServeur(`/trips/${tripId}/updates`, suivis);
    }
  }
  const supprimes = reponse?.deleted ?? contenu.deleted ?? reponse?.deletions ?? {};
  if (supprimes && !Array.isArray(supprimes)) {
    for (const [collection, ids] of Object.entries(supprimes)) {
      const kind = TYPE_DES_COLLECTIONS_DU_PULL[collection];
      if (kind && Array.isArray(ids)) {
        recus += ids.length;
        await supprimerEntitesServeur(kind, ids.map((id) => (id && typeof id === 'object' ? id.id : id)));
      }
    }
  }
  if (recus > 0) noterChangementRecu();
}

/**
 * Retire du modèle local ce qui a été supprimé en dur côté serveur (sans pierre
 * tombale): compare avec la liste des identifiants encore présents.
 */
export async function reconcilierSuppressions(chargerPage) {
  const presents = {};
  let decalage = 0;
  for (let garde = 0; garde < 50; garde += 1) {
    const page = await chargerPage({ offset: decalage });
    const donnees = page?.data || {};
    Object.entries(donnees).forEach(([collection, ids]) => {
      if (!Array.isArray(ids)) return;
      presents[collection] = (presents[collection] || []).concat(ids);
    });
    const pagination = page?.pagination;
    if (!pagination?.has_more || !Number.isInteger(pagination.next_offset)) break;
    decalage = pagination.next_offset;
  }
  for (const [collection, ids] of Object.entries(presents)) {
    const kind = TYPE_DES_COLLECTIONS_DU_PULL[collection];
    if (kind && TYPES_COUVERTS_PAR_LE_PULL.has(kind)) await purgerAbsentes(kind, ids);
  }
}
